import type { MutationTree } from 'vuex';

import {
  WinningMandateStep,
  type WinningMandateFormData,
  type WinningMandateLocation,
} from '@/models/winningMandate';

export interface WinningMandateState extends WinningMandateFormData {
  currentStep: WinningMandateStep;
}

export const getInitialWinningMandateState = (): WinningMandateState => ({
  currentStep: WinningMandateStep.GetStarted,
  sellerFirstName: '',
  sellerLastName: '',
  propertyAddress: null,
  includeLocationReport: false,
  includeHedonicValuation: false,
  hedonicValuationFile: null,
});

export const getters = {
  getWinningMandateCurrentStep: (state: WinningMandateState): WinningMandateStep =>
    state.currentStep,
  getWinningMandateSellerFirstName: (state: WinningMandateState): string => state.sellerFirstName,
  getWinningMandateSellerLastName: (state: WinningMandateState): string => state.sellerLastName,
  getWinningMandatePropertyAddress: (state: WinningMandateState): WinningMandateLocation | null =>
    state.propertyAddress,
  getWinningMandateIncludeLocationReport: (state: WinningMandateState): boolean =>
    state.includeLocationReport,
  getWinningMandateIncludeHedonicValuation: (state: WinningMandateState): boolean =>
    state.includeHedonicValuation,
  getWinningMandateHedonicValuationFile: (state: WinningMandateState): File | null =>
    state.hedonicValuationFile,
};

export const mutations: MutationTree<WinningMandateState> = {
  setWinningMandateCurrentStep(state, step: WinningMandateStep): void {
    state.currentStep = step;
  },
  setWinningMandateSellerFirstName(state, sellerFirstName: string): void {
    state.sellerFirstName = sellerFirstName;
  },
  setWinningMandateSellerLastName(state, sellerLastName: string): void {
    state.sellerLastName = sellerLastName;
  },
  setWinningMandatePropertyAddress(state, propertyAddress: WinningMandateLocation | null): void {
    state.propertyAddress = propertyAddress;
  },
  setWinningMandateIncludeLocationReport(state, includeLocationReport: boolean): void {
    state.includeLocationReport = includeLocationReport;
  },
  setWinningMandateIncludeHedonicValuation(state, includeHedonicValuation: boolean): void {
    state.includeHedonicValuation = includeHedonicValuation;
    if (!includeHedonicValuation) {
      state.hedonicValuationFile = null;
    }
  },
  setWinningMandateHedonicValuationFile(state, hedonicValuationFile: File | null): void {
    state.hedonicValuationFile = hedonicValuationFile;
  },
  resetWinningMandateState(state): void {
    Object.assign(state, getInitialWinningMandateState());
  },
};

const winningMandateStore = {
  state: getInitialWinningMandateState,
  getters,
  mutations,
};

export default winningMandateStore;
